<div>
  <button type="button" class="btn btn-primary mt-5 ml-3"
  (click)="toggleDisplayNew()">{{displayNewOnly ? 'Toon alle' : 'Toon nieuwe'}}</button>
  <div class="col-12 mt-5 ingredient-container">
    @for (ingredient of list; track trackById($index, ingredient)) {
      <div class="row ingredient-row">
        <div class="col-2">
          {{ingredient.name}}
        </div>
        <div class="col-10 mt-1 mb-1">
          <app-category-selector [selected]="ingredient.type"
          (select)="updateType(ingredient, $event)"></app-category-selector>
        </div>
      </div>
    }
    @if (displayNewOnly && !list.length) {
      <h2>
        Er zijn geen nieuwe ingrediënten om in te delen
      </h2>
    }
  </div>
</div>
